import React from 'react'
import { OurClient, Slider } from '../components'
import useScrollTop from '../hooks/useScrollTop';
import our_client_image from '../assets/img/our_client_image1.jpg';
import useDocTitle from '../hooks/useDocTitle';

const OurClientPage = () => {
    useScrollTop();
    useDocTitle("Our clients")

    return (
        <div className="bg-gray-50">
            <Slider image={our_client_image}/>

            <OurClient />
            
        </div>
    )
}

export default OurClientPage